export const stayPromotions = {
  title: "Promocje na pobyt",
  description: "Zaoferuj gościom specjalne rabaty na dłuższe pobyty",
  newPromotion: "Nowa promocja",
  loading: "Wczytywanie promocji...",
  close: "Zamknij",
  cancel: "Anuluj",
  noLimit: "Bez limitu",

  status: {
    active: "Aktywna",
    paused: "Wstrzymana",
  },

  card: {
    stay: "Pobyt",
    discount: "Rabat",
    validity: "Ważność",
    edit: "Edytuj",
    delete: "Usuń",
  },

  nights: {
    range: "{min} - {max} nocy",
    min: "{min}+ nocy",
  },

  empty: {
    title: "Brak skonfigurowanych promocji",
    description: "Twórz promocje, które zachęcą do dłuższych pobytów i zwiększą liczbę rezerwacji",
    create: "Utwórz pierwszą promocję",
  },

  form: {
    editTitle: "Edytuj promocję",
    createTitle: "Nowa promocja",
    nameLabel: "Nazwa promocji",
    namePlaceholder: "np. Rabat na 7 nocy, Oferta tygodniowa",
    minNights: "Minimalna liczba nocy",
    maxNights: "Maksymalna liczba nocy",
    optional: "(opcjonalnie)",
    noLimitPlaceholder: "Bez limitu",
    discountType: "Rodzaj rabatu",
    percentage: "Procentowy",
    fixedAmount: "Kwota stała",
    discountValue: "Wartość rabatu",
    validFrom: "Ważna od",
    validTo: "Ważna do",
    activateNow: "Aktywuj promocję od razu",
    saving: "Zapisywanie...",
    update: "Zaktualizuj",
    create: "Utwórz promocję",
  },

  invoice: {
    title: "Przykład oszczędności",
    pricePerNight: "Cena za noc",
    numberOfNights: "Liczba nocy",
    subtotal: "Suma częściowa",
    discountApplied: "Naliczony rabat",
    totalToPay: "Razem do zapłaty",
    guestSaves: "Gość oszczędza {amount}",
  },

  statusModal: {
    activateTitle: "Aktywuj promocję",
    pauseTitle: "Wstrzymaj promocję",
    activateDescription: 'Czy aktywować promocję "{name}", aby obowiązywała dla nowych rezerwacji?',
    pauseDescription: 'Czy wstrzymać promocję "{name}"?',
    confirm: "Potwierdź",
  },

  deleteModal: {
    title: "Usuń promocję",
    warningStrong: "Tej operacji nie można cofnąć.",
    warningText: "Przed usunięciem upewnij się, że promocja {name} nie jest już potrzebna.",
    confirmLabel: "Wpisz dokładną nazwę, aby potwierdzić:",
    confirmPlaceholder: "Wpisz dokładnie nazwę promocji",
    hint: "Wklej lub wpisz nazwę dokładnie tak, jak widnieje powyżej, aby odblokować przycisk usuwania.",
    deleting: "Usuwanie...",
    confirmDelete: "Usuń trwale",
  },

  toasts: {
    nameRequired: "Wpisz nazwę",
    minNightsWarning: "Minimalna liczba nocy musi wynosić co najmniej 1",
    selectRatePlan: "Wybierz bazowy plan cenowy",
    updated: "Promocja zaktualizowana",
    created: "Promocja utworzona",
    saveFailed: "Nie udało się zapisać",
    saveError: "Błąd podczas zapisywania",
    activated: "Promocja aktywowana",
    pausedToast: "Promocja wstrzymana",
    updateFailed: "Nie udało się zaktualizować",
    statusError: "Błąd podczas zmiany statusu",
    deleted: "Promocja usunięta",
    deleteFailed: "Nie udało się usunąć",
    deleteError: "Błąd podczas usuwania",
  },
};
